import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { CompanyClusterConversionCompanyDto, companyClusterConversionCompanyValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface ClusterConversionCompanyAddEditDialogProps {
  initialValues: CompanyClusterConversionCompanyDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function ClusterConversionCompanyAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: ClusterConversionCompanyAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={companyClusterConversionCompanyValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Cluster Conversion Company</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.clusterConversionCompanyCode && errors.clusterConversionCompanyCode)}
                      helperText={touched.clusterConversionCompanyCode && errors.clusterConversionCompanyCode}
                      label='Cluster Conversion Company Code'
                      name='clusterConversionCompanyCode'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.clusterConversionCompanyCode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      ||All fields are required.|| Cluster Conversion Company Code must be 3 characters. ||
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
